<template>
  <div class="czewm-box">
    <div class="czewm-content">
      <img class="czewm-qrcode" src="../../../assets/image/ewm.png" alt="" />
      <span class="czewm-label">NB Chain {{$t('all.chongbidizhi')}}</span>
      <div class="czewm-address">
        <span class="czewm-address-text">0x82...8F91</span>
		<img class="czewm-address-copy" src="../../../assets/image/fuzhi_18@2x.png" alt=""  @click="handleCopy"/>
      </div>
      <div class="czewm-btn-gradient" @click="handleSaveQr">{{$t('all.baocunerweima')}}</div>
      <div class="czewm-btn" @click="handleCopy">{{$t('all.fuzhidizhi')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleSaveQr() {
      this.$router.push('/chongzhichenggong');
    },
    handleCopy() {
      navigator.clipboard.writeText('0x82...8F91');
      this.$message.success(this.$t('all.fuzhichenggong'));
    }
  }
};
</script>

<style scoped lang="scss">
.czewm-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 130px);
  padding: 0 20px;
}

.czewm-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  width: 100%;
}

.czewm-qrcode {
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
}

.czewm-label {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  margin-bottom: 10px;
}

.czewm-address {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;
}

.czewm-address-text {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #369AFF;
}

.czewm-address-copy {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

.czewm-btn-gradient {
  width: 300px;
  height: 48px;
  background: linear-gradient( 90deg, #6BEEFE 0%, #0595F3 34.95%, #7300DF 67.82%, #9A00A8 100%);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  cursor: pointer;
  margin-bottom: 12px;
}
.czewm-btn-gradient:hover {
  opacity: 0.9;
}

.czewm-btn {
  width: 300px;
  height: 48px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  cursor: pointer;
}
.czewm-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}
</style>



// WEBPACK FOOTER //
// chongzhierweima.vue?1e7e76a5